<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="reporte_documentos_firmar")
        reporte-cursos-virtuales-terminados

</template>

<script>
import ReporteCursosVirtuales from '../components/c_reporte_cursos_terminado_alumnos'
export default {
  name: 'view_reporte_cursos_virtuales',
  components: {
    'reporte-cursos-virtuales-terminados': ReporteCursosVirtuales
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Reporte_Curso_Terminado_Alumno.vue?4fd6af82